export function activeTheme({ commit }, data) {
  commit('activeTheme', data)
}

export function activeTab({ commit }, data) {
  commit('activeTab', data)
}

export function activeTabMechanism({ commit }, data) {
  commit('activeTabMechanism', data)
}

export function activeTabPlate({ commit }, data) {
  commit('activeTabPlate', data)
}

export function preset({ commit }, data) {
  commit('preset', data)
}

export function custom({ commit }, data) {
  commit('custom', data)
}

export function cart({ commit }, data) {
  commit('cart', data)
}
export function getTotalPrice({ commit }, data) {
  commit('getTotalPrice', data)
}
